export { default as NewYearBallons } from './ballons.webp';
export { default as NewYearCake } from './cake.webp';
export { default as NewYearChampagne } from './champagne.webp';
export { default as NewYearBanner } from './happy-newyear-banner.webp';
export { default as NewYearHat } from './hat.webp';
export { default as NewYearRibbon1 } from './ribbon-1.webp';
export { default as NewYearRibbon2 } from './ribbon-2.webp';
export { default as NewYearBow } from './bow.webp';
export { default as NewYearCrown } from './crown.webp';
export { default as NewYearStarWithRibbon } from './star-with-ribbon.webp';
export { default as NewYearStar } from './star.webp';
